import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Invoice } from "src/app/purchase/invoice/invoice";
import { Page } from "src/app/util/page";
import { Supplier } from "../supplier/supplier";
import { AddReferenceToReceptionResult } from "./add-reference-to-reception-result";
import { Reception } from "./reception";
import { ReceptionInvoiceStatus } from "./reception-invoice-status";
import { ReceptionSearchResult } from "./reception-search-result";
import { SearchRequest } from "./search-request";

@Injectable()
export class ReceptionService {
  constructor(private httpClient: HttpClient) {

  }

  public addReference(receptionId: string, isbn: string): Observable<AddReferenceToReceptionResult> {
    return this.httpClient.post<AddReferenceToReceptionResult>(
      `/api/inventory/reception/${receptionId}/${isbn}?createIsbn=false`,
      {}
    );
  }

  public confirm(id: string): Observable<Reception> {
    return this.httpClient.put<Reception>(`/api/inventory/reception/${id}?confirm`, {});
  }

  public createReference(receptionId: string, isbn: string, title: string, price: number): Observable<AddReferenceToReceptionResult> {
    let params = `createIsbn=true&title=${title}&price=${Math.round(price * 100)}`;

    return this.httpClient.post<AddReferenceToReceptionResult>(`/api/inventory/reception/${receptionId}/${isbn}?${params}`, {});
  }

  public receptionInvoiceStatus(supplierId: string, supplierInvoiceNumber: string) {
    let params = `supplierId=${supplierId}&supplierInvoiceNumber=${supplierInvoiceNumber}`;

    return this.httpClient.get<ReceptionInvoiceStatus>(`/api/inventory/reception/invoice-status?${params}`)
  }

  public findById(id: string): Observable<Reception> {
    return this.httpClient.get<Reception>(`/api/inventory/reception/${id}`);
  }

  public findByInvoice(invoice: string): Observable<Reception[]> {
    return this.httpClient.get<Reception[]>(`/api/inventory/reception?invoice=${invoice}`);
  }

  public newReceptionByInvoice(invoice: string): Observable<Reception> {
    return this.httpClient.post<Reception>(`/api/inventory/reception?invoiceId=${invoice}`, {});
  }

  public newReception(
    supplier: Supplier,
    invoiceId: string | null,
    unknownSupplierInvoiceNumber: string
  ): Observable<Reception> {
    let params = `supplierId=${supplier.id}&invoiceId=${invoiceId != null ? invoiceId : ""}&unknownSupplierInvoiceNumber=${unknownSupplierInvoiceNumber}`;

    return this.httpClient.post<Reception>(`/api/inventory/reception?${params}`, {});
  }

  public removeDetail(reception: string, isbn: string): Observable<void> {
    return this.httpClient.delete<void>(`/api/inventory/reception/${reception}/${isbn}`);
  }

  public reopen(reception: string): Observable<Reception> {
    return this.httpClient.post<Reception>(`/api/inventory/reception/${reception}?reopen`, {});
  }

  public search(searchRequest: SearchRequest, page: number, size: number): Observable<Page<ReceptionSearchResult>> {
    return this.httpClient.post<Page<ReceptionSearchResult>>(
      `/api/inventory/reception?search&page=${page}&size=${size}&sort=creationTimestamp,DESC`,
      searchRequest,
    );
  }
}